import React from 'react'
import {
  CardStyleInterpolators,
  createStackNavigator,
  StackNavigationOptions,
} from '@react-navigation/stack'
import { useSelector } from 'react-redux'
import { productsSelector } from '@src/selectors/app'
import { useActiveSubscriptions } from '@src/hooks/useActiveSubscriptions'
import { useReducedMotion } from '@src/config/accessibility'
import { NewMarketplaceScreen } from '@screens/Marketplace'
import { SubscriptionOptionsScreen } from '@screens/SignUp'
import { SubscriptionsStackParamsList } from '../types'

const SubscriptionsStack = createStackNavigator<SubscriptionsStackParamsList>()

export const SubscriptionsNavigator = () => {
  const reduceMotionEnabled = useReducedMotion()

  const screenOptions: StackNavigationOptions = {
    headerShown: false,
    cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
  }

  if (reduceMotionEnabled) {
    screenOptions.animation = 'none'
  }

  const activeSubscriptions = useActiveSubscriptions()

  const products = useSelector(productsSelector)

  const showPlanPicker = activeSubscriptions.length === 0 && products.length > 1

  return (
    <SubscriptionsStack.Navigator
      initialRouteName={showPlanPicker ? 'SubscriptionOptions' : 'Marketplace'}
      screenOptions={screenOptions}
    >
      {showPlanPicker ? (
        <SubscriptionsStack.Screen
          name="SubscriptionOptions"
          component={SubscriptionOptionsScreen}
        />
      ) : (
        <SubscriptionsStack.Screen name="Marketplace" component={NewMarketplaceScreen} />
      )}
    </SubscriptionsStack.Navigator>
  )
}
